export default "__VITE_ASSET__B$TCvkQZ__"